import { z } from 'zod';

/** Briques de champ réutilisées par les schémas d'entrée du domaine agenda. */

export const trimmed = (max: number) => z.string().trim().min(1).max(max);

/** Texte facultatif : la chaîne vide devient `null`, pour ne jamais stocker deux formes du vide. */
export const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .transform((v) => (v === '' ? null : v))
    .nullable();

/** Heure murale `HH:MM` sur 24 heures. Les règles de disponibilité sont des heures locales du cabinet. */
export const timeOfDaySchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Heure attendue HH:MM');

/** Couleur hexadécimale `#rrggbb`. Le front n'affiche jamais une couleur brute venue d'ailleurs. */
export const hexColorSchema = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/, 'Couleur hexadécimale attendue');

/** `YYYY-MM-DD` réellement existante : `z.iso.date()` laisse passer le 30 février. */
export const dateOnlySchema = z.iso.date().refine((value) => {
  const [y, m, d] = value.split('-').map(Number);
  if (y === undefined || m === undefined || d === undefined) return false;
  const parsed = new Date(Date.UTC(y, m - 1, d));
  return (
    parsed.getUTCFullYear() === y && parsed.getUTCMonth() === m - 1 && parsed.getUTCDate() === d
  );
}, 'Date inexistante');
